
// functions
export function setEventDelay(arg, f, ms, init = false, ...args) { // задержка для функции. init = true выполнить функцию до установки таймера.
    let timer = null

    function eventToArgs(e, args) {
        const argsLength = args.length
        if (argsLength <= args.length) {
            args[0] = e
        } else {
            args.unshift(e)
        }
    }

    function executor(e) {

        if (!timer) {
            if (init) {
                timer = setTimeout(() => {
                    clearTimeout(timer)
                    timer = null
                }, ms, e)
                eventToArgs(e, args)
                f(arg, ...args)
            } else {
                timer = setTimeout(
                    function () {
                        clearTimeout(timer)
                        timer = null
                        eventToArgs(e, args)
                        f(arg, ...args)
                    },
                    ms,
                    e
                )
            }
        }
    }

    return executor
}

export function parseDataSelector(data_selector) {
    if (!data_selector) return []
    let str = data_selector.replace(/(\[|\]|'|")/gm, '')
    let key = null
    let value = null

    if ( str.indexOf('=') === -1 ) {
        key = str.replace(/(data-| )/gm, '')
        return [key, null]
    }
    let tmp = str.split('=')
    key = tmp[0].replace(/(data-| )/gm, '')
    key = key.split('-')
        .map((word, index) => {
            let result = word
            if (index !== 0) {
                result = word[0].toUpperCase() + word.substring(1)
            }

            return result
        })
        .join('')

    value = tmp[1]
    let result = [key, value]

    if (value) {
        tmp = value.split(':')
        if (tmp.length === 2) {
            result.push(tmp)
        }
    }

    return result
}

export function delArrayItemByIndex( array, index ) {
    let clone = [...array]
    return [...clone.slice(0, index), ...clone.slice(index + 1)]
}

export function delArrayItemByItem( array, item ) {
    if (!array.length) return false
    let index = array.findIndex( i => i === item)
    if ( index === -1) return array
    let clone = [...array]
    return [...clone.slice(0, index), ...clone.slice(index + 1)]
}

export function getWindowWidth() {
    return window.innerWidth
}

export function getScrollDirection() {
    if ( typeof scrollPos === 'undefined' ) window.scrollPos = 0

    return (function() {
        let direction = null
        if ( (document.body.getBoundingClientRect()).top > scrollPos ) {
            direction = 'up';
        } else {
            direction = 'down';
        }
        scrollPos = (document.body.getBoundingClientRect()).top;
    
        return direction
    })();
}

export function isHide(elem) {
    let width = elem.offsetWidth
    let height = elem.offsetHeight
    let styles = window.getComputedStyle(elem)

    return ((width === 0 && height === 0) || (elem.style && elem.style.display) || (styles.display && styles.display === "none"))
}

/**
 * склоняет существительное в зависимости от количества
 * пример: declension(7, "товар", "товара", "товаров") вернет 'товаров'
 * пример: declension(5, 'год', 'года', 'лет') вернет 'лет'
 * @param int count
 * @param string nominative именительный падеж год
 * @param string genitive родительный падеж лет
 * @param string plural множественное число года
 * @return string
 */
export function declension(count, nominative, genitive, plural, withNumber=false) {
    let m = count % 10;
    let j = count % 100;
    let result = ''
    if (m == 0 || m >= 5 || (j >= 10 && j <= 20)) {
        result = plural;
    } else if (m >= 2 && m <= 4) {
        result = genitive;
    } else {
        result = nominative;
    }

    return withNumber ? `${count} ${result}` : result
}

/**
 * возвращает смещение элемента относительно документа
 * @param {HTMLElement} element 
 * @returns 
 */
export function getFullOffsetTop(element) {
    if (!element) return false

    let offset = +element.offsetTop
    let parent = element.offsetParent

    do {
        if (parent === null) break
        offset += parent.offsetTop

        if (parent.offsetParent === null) break
        parent = parent.offsetParent
    }
    while (parent.offsetParent)

    return offset
}

export function getRelativeOffset(element, target) {
    if ( !(target && target instanceof HTMLElement) ) {
        console.error('empty target')
        return null
    }

    let offsetTop = +element.offsetTop
    let offsetLeft = +element.offsetLeft
    let parent = element.offsetParent

    do {
        if (parent === target) break
        if (parent === null) {
            console.error('target not found')
            return null
        }
        offsetTop += parent.offsetTop
        offsetLeft += parent.offsetLeft

        if (parent.offsetParent === null) break
        parent = parent.offsetParent
    }
    while (parent.offsetParent)

    return {
        top: offsetTop,
        left: offsetLeft,
    }

}

export function isTouch() {
    return !!('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch));
}

export function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

export function smoothScrollByElement(element, topOffset=0) {
    if (!element) return false
    
    let scrollTarget = element;
    let elementPosition = scrollTarget.getBoundingClientRect().top;
    let offsetPosition = elementPosition - topOffset;

    window.scrollBy({
        top: offsetPosition,
        behavior: 'smooth'
    });
}
